<template>
  <ex-card class="ex-toolbar-product pa-0">
    <div class="d-flex align-center">
      <v-btn
        text
        :ripple="false"
        class="ma-0 mr-1 ex-btn ex-opacity-btn square-btn px-0"
        @click="productPrevious()">
      <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-btn
        text
        :ripple="false"
        class="ma-0 mr-1 ex-btn ex-opacity-btn square-btn px-0"
        @click="productForward()">
        <v-icon>arrow_forward</v-icon>
      </v-btn>
      <v-btn
        text
        :ripple="false"
        :disabled="productsCount === 0"
        class="ma-0 ex-btn ex-primary-btn"
        @click="openDialog()">
        <v-icon class="mr-2">vertical_split</v-icon> All Products
      </v-btn>
      <div class="ml-3">Total: {{productsCount === 0 ? '0' :  productsCount}}</div>
    </div>
  </ex-card>
</template>

<script>
export default {
  name: 'Toolbar',
  props: {
    searchData: {
      type: [Object, Array],
      default: null
    },
    dataOfClients: {
      type: [Object, Array],
      default: null
    },
    productsCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    dataOfClientsID: 0
  }),
  methods: {
    openDialog () {
      this.$emit('showProductList')
      this.searchData.dialogData.show = true
    },
    productPrevious () {
      alert('Previous')
    },
    productForward () {
      alert('Forward')
    },
    selectedClient (clientId) {
      this.$emit('clientInfo', clientId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/Toolbar.vue